import {StackActions, useNavigation, useRoute} from '@react-navigation/native';
import React, {useEffect} from 'react';
import analytics from '@react-native-firebase/analytics';
import {Header} from '../../../components/Interface/Headers/Header';
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {FipeResponseDTO} from '../../../dtos/FipeDTO';
import {
  Container,
  Content,
  ContentHeader,
  FinesCardWrapper,
  FipeArea,
  Footer,
  Item,
  ItemContainer,
  ItemFipe,
  ItemName,
  Label,
  LabelFipe,
  LabelTitle,
  MainItem,
  TitleContainer,
} from './styles';
import {Icon} from '../../../components/Interface/Typographies/Icon';
import {useHelpers} from '../../../context/helpers';
import {Ads} from '../../../components/shared/Ads';
import {Platform} from 'react-native';
import {addInAppTrigger} from '../../../lib/pushMessaging';
import {useGlobal} from '../../../context/global';
import {FinesReminderCard} from '../../../components/shared/FinesReminderCard';

interface Params {
  data: FipeResponseDTO;
}

export function FipeDetails() {
  const route = useRoute();
  const navigation = useNavigation();
  const {formatStringToLocaleAmount} = useHelpers();
  const {fetchBannerFlags} = useGlobal();
  const {data} = route.params as Params;

  useEffect(() => {
    analytics().logEvent('tela_detalhes_fipe');
  }, []);

  useEffect(() => {
    fetchBannerFlags();
  }, []);

  const popAction = StackActions.pop(2);

  useEffect(() => {
    if(Platform.OS !== 'web'){
      addInAppTrigger('screen', 'fipe_detalhes');
    }
  }, []);

  return (
    <Container>
      <Header
        icon="chevron-left"
        action={() => navigation.dispatch(popAction)}
      />
      <Content>
        <ContentHeader>
          <Titles title="Dados do veículo:" />
        </ContentHeader>
        <MainItem>
          <TitleContainer>
            <LabelTitle>{data.informacoes_veiculo.marca}</LabelTitle>
            <LabelTitle>{data.informacoes_veiculo.modelo}</LabelTitle>
          </TitleContainer>
          <FipeArea>
            <LabelFipe>Valor FIPE:</LabelFipe>
            <ItemFipe>
              {formatStringToLocaleAmount(data.fipe[0].valor)}
            </ItemFipe>
          </FipeArea>
        </MainItem>
        <Item>
          <Icon name="calendar" awesome5 />
          <ItemContainer>
            <Label>Ano</Label>
            <ItemName>
              {data.informacoes_veiculo.ano}/
              {data.informacoes_veiculo.ano_modelo}
            </ItemName>
          </ItemContainer>
        </Item>
        <Item>
          <Icon name="paint-roller" awesome5 />
          <ItemContainer>
            <Label>Cor</Label>
            <ItemName>{data.informacoes_veiculo.cor}</ItemName>
          </ItemContainer>
        </Item>
        <Item>
          <Icon name="car-side" awesome5 />
          <ItemContainer>
            <Label>Chassi</Label>
            <ItemName>{data.informacoes_veiculo.chassi}</ItemName>
          </ItemContainer>
        </Item>
        <Item>
          <Icon name="map-marker-alt" awesome5 />
          <ItemContainer>
            <Label>Cidade/Estado</Label>
            <ItemName>
              {data.informacoes_veiculo.municipio} -{' '}
              {data.informacoes_veiculo.uf}
            </ItemName>
          </ItemContainer>
        </Item>
        <Item>
          <Icon name="gas-pump" awesome5 />
          <ItemContainer>
            <Label>Combustível</Label>
            <ItemName>{data.informacoes_veiculo.combustivel}</ItemName>
          </ItemContainer>
        </Item>
        <Item>
          <Icon name="car" awesome5 />
          <ItemContainer>
            <Label>Placa</Label>
            <ItemName>{data.informacoes_veiculo.placa}</ItemName>
          </ItemContainer>
        </Item>
        <Item>
          <Icon name="barcode" awesome5 />
          <ItemContainer>
            <Label>Código FIPE</Label>
            <ItemName>{data.fipe[0].codigo_fipe}</ItemName>
          </ItemContainer>
        </Item>
        <FinesCardWrapper>
          <FinesReminderCard />
        </FinesCardWrapper>
      </Content>
      <Footer>
        <Ads />
      </Footer>
    </Container>
  );
}